export enum BackendApiType {
  XVI = 'xvi',
  DM = 'dm',
  PORTAL = 'portal',
  RPT = 'rpt',
  AUDIT_TRAIL = 'audit_trail',
}
